import { Instant, PlainDate, PlainDateTime, PlainTime } from "./polyfill";
export function tryParsePlainDate(value) {
    return tryParseString(value, v => PlainDate.from(v, { overflow: "reject" }));
}
export function tryParsePlainDateTime(value) {
    return tryParseString(value, v => PlainDateTime.from(v, { overflow: "reject" }));
}
export function tryParsePlainTime(value) {
    return tryParseString(value, v => PlainTime.from(v, { overflow: "reject" }));
}
export function tryParseInstant(value) {
    return tryParseString(value, Instant.from);
}
function tryParseString(value, parseFn) {
    if (value) {
        try {
            return parseFn(value);
        }
        catch (error) {
            // ignore parse error
        }
    }
    return null;
}
//# sourceMappingURL=parse.js.map